import { deleteField, doc, updateDoc } from "firebase/firestore";
import { ECreditType } from '@leedpulse-monorepo/enums';
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Subscription from "../../models/Subscription";
import SubscriptionTimezoneCity from "../../enums/subscription/subscription_timezone/SubscriptionTimezoneCity";
import SubscriptionTimezoneContinent from "../../enums/subscription/subscription_timezone/SubscriptionTimezoneContinent";
import SubscriptionTimezoneCountry from "../../enums/subscription/subscription_timezone/SubscriptionTimezoneCountry";

async function updateSubscription(
  subscription: Subscription,
  opts: { clearedCredits?: ECreditType[]; keepPlan?: boolean } = {}
): Promise<void> {
  try {
    const subscriptionPatch = subscription.toFirestorePatch();

    for (const k of opts.clearedCredits ?? []) subscriptionPatch[`credits.${k}`] = deleteField();

    // The backend moves the plan too (change of plan, renewal): a page loaded before would put the old one back
    if (opts.keepPlan) delete subscriptionPatch.id_plan;

    const db = firestore;

    // Force values to be from dedicated enums
    if(subscriptionPatch.timezone) {
      if(!Object.values(SubscriptionTimezoneCountry).includes(subscriptionPatch.timezone.country)) {
        throw new UpdateSubscriptionFailure("Invalid timezone country");
      }
      if(!Object.values(SubscriptionTimezoneCity).includes(subscriptionPatch.timezone.city)) {
        throw new UpdateSubscriptionFailure("Invalid timezone city");
      }
      if(!Object.values(SubscriptionTimezoneContinent).includes(subscriptionPatch.timezone.continent)) {
        throw new UpdateSubscriptionFailure("Invalid timezone continent");
      }
    }

    await updateDoc(
      doc(db, FirestoreCollections.subscriptions, subscription.id),
      subscriptionPatch
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    throw new UpdateSubscriptionFailure();
  }
}

export class UpdateSubscriptionFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updateSubscription;
